import { FiEyeOff, FiEye  } from "react-icons/fi"
import React, { useState } from "react"

export const inputText = (args) => {
  const { register, placeholder, errors, name, label, isRequired = true } = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}><b>{label}</b></label>
      <input
        {...register(name, isRequired && { required: `* Campo requerido` })}
        type='text'
        placeholder={`${placeholder}`}
        className='form-control'
      />
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const inputTextDisabled = (args) => {
  const { register, placeholder, errors, name, label} = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}><b>{label}</b></label>
      <input
        {...register(name )}
        type='text'
        disabled
        placeholder={`${placeholder}`}
        className='form-control'
      />
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const inputTel = (args) => {
  const { register, placeholder, errors, name, label, isRequired = true } = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}><b>{label}</b></label>
      <input
        {...register(name, isRequired && { required: `* Campo requerido` })}
        type='tel'
        placeholder={`${placeholder}`}
        className='form-control'
      />
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const inputTextArea = (args) => {
  const { register, placeholder, errors, name, label, isRequired = true } = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}><b>{label}</b></label>
      <textarea
        rows='5'
        cols='30'
        {...register(name, isRequired && { required: `* Campo requerido` })}
        type='text'
        placeholder={`${placeholder}`}
        className='form-control'
      />
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const inputNumber = (args) => {
  const { register, placeholder, errors, name, label, isRequired = true } = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}><b>{label}</b></label>
      <input
        {...register(name, isRequired && { required: `* Campo requerido` })}
        type='number'
        placeholder={`${placeholder}`}
        className='form-control'
      />
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const inputEmail = (args) => {
  const { register, placeholder, errors, label, name } = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}>{label}</label>
      <input
        {...register(name, {
          required: `* Campo requerido`,
          pattern: {
            value: /\S+@\S+\.+\S+/,
            message: 'El valor ingresado no coincide con el formato de correo electrónico',
          },
        })}
        type='email'
        placeholder={`${placeholder}`}
        className='form-control'
      />
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const inputEmailDisabled = (args) => {
  const { register, placeholder, errors, label, name } = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}>{label}</label>
      <input
        {...register(name)}
        type='email'
        placeholder={`${placeholder}`}
        className='form-control'
        disabled
      />
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const inputPassword = (args) => {
  const {
    register,
    placeholder,
    errors,
    watch,
    name,
    validate = false,
    isRequired = true,
    minLength = false,
  } = args
  const [type, setType] = useState('password')
  const [icon, setIcon] = useState(FiEyeOff)

  const handleToggle = () => {
    if (type==='password'){
       setIcon(FiEye)
       setType('text')
    } else {
       setIcon(FiEyeOff)
       setType('password')
    }
 }

  return (
    <div className='mb-3 flex'>
      <label htmlFor={name}>&nbsp;</label>
      <input
        {...register(name, {
          required: isRequired ? `* Campo requerido` : null,
          minLength: minLength
            ? {
                value: 6,
                message: 'La contraseña debe tener al menos 6 caracteres.',
              }
            : null,
          validate: validate
            ? (value) =>
                value === watch().password || ' Las contraseñas no coinciden'
            : null,
        })}
        type={type}
        placeholder={`${placeholder}`}
        className='form-control'
      />
      <span className="flex justify-around items-center" onClick={handleToggle}>
        <p className="input-password">{icon}</p>
      </span>
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const dynamicInputSelect = (args) => {
  const {
    register,
    placeholder,
    errors,
    name,
    label,
    data,
    isRequired = true,
    value,
  } = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}><b>{label}</b></label>
      <select
        {...register(name, isRequired && { required: `* Campo requerido` })}
        type='text'
        placeholder={`${placeholder}`}
        className='form-control'
      >
        <option value=''>Seleccione una opción</option>
        {data &&
          data.map((d) => (
            <option key={d._id} value={d._id}>
              {d[value]}
            </option>
          ))}
      </select>
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const staticInputSelect = (args) => {
  const {
    register,
    placeholder,
    errors,
    name,
    data,
    label,
    isRequired = true,
  } = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}><b>{label}</b></label>
      <select
        {...register(name, isRequired && { required: `* Campo requerido` })}
        type='text'
        placeholder={`${placeholder}`}
        className='form-control'
      >
        <option value=''>Seleccione una opción</option>
        {data &&
          data.map((d) => (
            <option key={d.name} value={d._id}>
              {d.name}
            </option>
          ))}
      </select>
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const inputCheckBox = (args) => {
  const { register, errors, name, label, isRequired = true } = args

  return (
    <div className='mb-3'>
      <div className='form-check form-switch form-control'>
        <input
          className='form-check-input'
          type='checkbox'
          id={name}
          {...register(
            name,
            isRequired && { required: `* Campo requerido` }
          )}
        />
        <label className='form-check-label' htmlFor={name}>
          {label}
        </label>
      </div>
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const inputMultipleCheckBox = (args) => {
  const { register, errors, name, data, isRequired = true } = args

  return (
    <div className='mb-3'>
      <div className='row g-1 mb-3'>
        {data &&
          data.map((d) => (
            <div key={d._id} className='col-md-4 col-6'>
              <div className='form-check form-switch'>
                <input
                  {...register(
                    name,
                    isRequired && { required: `* Campo requerido` }
                  )}
                  className='form-check-input'
                  type='checkbox'
                  value={d._id}
                  id={`flexCheck${d._id}`}
                />
                <label
                  className='form-check-label'
                  htmlFor={`flexCheck${d._id}`}
                >
                  {d.name}
                </label>
              </div>
            </div>
          ))}
      </div>
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const inputFile = (args) => {
  const {
    register,
    placeholder,
    errors,
    name,
    isRequired = true,
    label,
    setFile,
  } = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}>{label}</label>
      <input
        {...register(name, isRequired && { required: `* Campo requerido` })}
        type='file'
        placeholder={`${placeholder}`}
        className='form-control'
        id='formFile'
        onChange={(e) => setFile(e.target.files[0])}
      />
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const inputDate = (args) => {
  const { register, placeholder, errors, name, label, isRequired = true } = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}><b>{label}</b></label>
      <input
        {...register(name, isRequired && { required: `* Campo requerido` })}
        type='date'
        placeholder={`${placeholder}`}
        className='form-control'
      />
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const InputAutoCompleteSelect = (args) => {
  const {
    register,
    placeholder,
    errors,
    name,
    data,
    label,
    isRequired = true,
  } = args

  return (
    <div className='mb-3'>
      <label htmlFor='exampleDataList' className='form-label'>
        {label}
      </label>
      <input
        list='datalistOptions'
        autoComplete='off'
        id='exampleDataList'
        {...register(name, isRequired && { required: `* Campo requerido` })}
        type='text'
        placeholder={`${placeholder}`}
        className='form-control'
      />
      <datalist id='datalistOptions'>
        <option value=''>Seleccione una opción</option>
        {data &&
          data.map((d) => (
            <option key={d._id} value={d._id}>
              {d.name}
            </option>
          ))}
      </datalist>

      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}

export const dynamicInputSelectNumber = (args) => {
  const {
    register,
    placeholder,
    errors,
    name,
    label,
    data,
    isRequired = true,
  } = args

  return (
    <div className='mb-3'>
      <label htmlFor={name}>{label}</label>
      <select
        {...register(name, isRequired && { required: `* Campo requerido` })}
        type='text'
        placeholder={`${placeholder}`}
        className='form-control'
      >
        <option value=''>Seleccione una opción</option>

        {[...Array(data).keys()].map((num) => (
          <option key={num + 1} value={num + 1}>
            {num + 1}
          </option>
        ))}
      </select>
      {errors && errors[name] && (
        <span className='text-danger'>{errors[name].message}</span>
      )}
    </div>
  )
}
